module.exports = __webpack_public_path__ + "assets/img/file-tab-active.97241fab.svg";